// extracted by mini-css-extract-plugin
module.exports = {"container":"onfido-sdk-ui-Pannable-container"};